module.exports = __webpack_public_path__ + "static/img/bj.39ddea16.jpg";